(() => {
  const KLAVIYO_HEADING_SELECTOR = '.klaviyo-form-richtext h1';
  const KLAVIYO_IMAGE_SELECTOR =
    'img.needsclick[src*="d3k81ch9hvuctc.cloudfront.net/company/WchPji/"]';
  const JUDGEME_IMAGE_SELECTOR = '.jdgm-write-review-modal__product-image img';
  const APP_IMAGE_SELECTOR = `${KLAVIYO_IMAGE_SELECTOR}, ${JUDGEME_IMAGE_SELECTOR}`;
  const APP_TARGET_SELECTOR = `${KLAVIYO_HEADING_SELECTOR}, ${APP_IMAGE_SELECTOR}`;

  function imageSourceKey(image) {
    try {
      const path = new URL(image.currentSrc || image.src, document.baseURI).pathname;
      return path.split('/').pop() || '';
    } catch (error) {
      return '';
    }
  }

  function knownImageDimensions(image) {
    if (image.naturalWidth > 0 && image.naturalHeight > 0) {
      return { width: image.naturalWidth, height: image.naturalHeight };
    }

    const sourceKey = imageSourceKey(image);
    if (!sourceKey) return null;

    const match = Array.from(document.images).find((candidate) => {
      if (candidate === image || imageSourceKey(candidate) !== sourceKey) return false;

      const width = candidate.naturalWidth || Number.parseInt(candidate.getAttribute('width'), 10);
      const height = candidate.naturalHeight || Number.parseInt(candidate.getAttribute('height'), 10);
      return width > 0 && height > 0;
    });

    if (!match) return null;

    return {
      width: match.naturalWidth || Number.parseInt(match.getAttribute('width'), 10),
      height: match.naturalHeight || Number.parseInt(match.getAttribute('height'), 10),
    };
  }

  function addIntrinsicDimensions(image) {
    if (!(image instanceof HTMLImageElement)) return;
    if (image.hasAttribute('width') && image.hasAttribute('height')) return;

    const applyDimensions = () => {
      const dimensions = knownImageDimensions(image);
      if (!dimensions) return false;

      if (!image.hasAttribute('width')) image.setAttribute('width', String(dimensions.width));
      if (!image.hasAttribute('height')) image.setAttribute('height', String(dimensions.height));
      return true;
    };

    if (applyDimensions() || image.dataset.mblDimensionListener === 'true') return;

    image.dataset.mblDimensionListener = 'true';
    image.addEventListener(
      'load',
      () => {
        applyDimensions();
        delete image.dataset.mblDimensionListener;
      },
      { once: true }
    );
  }

  function demoteKlaviyoHeading(heading) {
    if (!(heading instanceof HTMLHeadingElement) || heading.tagName !== 'H1') return;

    const replacement = document.createElement('h2');
    for (const attribute of heading.attributes) {
      replacement.setAttribute(attribute.name, attribute.value);
    }
    while (heading.firstChild) replacement.appendChild(heading.firstChild);
    heading.replaceWith(replacement);
  }

  function normalizeRoot(root) {
    if (!(root instanceof Document || root instanceof Element)) return;

    if (root instanceof Element) {
      if (root.matches(KLAVIYO_HEADING_SELECTOR)) demoteKlaviyoHeading(root);
      if (root.matches(APP_IMAGE_SELECTOR)) addIntrinsicDimensions(root);
    }

    root.querySelectorAll(APP_TARGET_SELECTOR).forEach((element) => {
      if (element instanceof HTMLImageElement) addIntrinsicDimensions(element);
      else demoteKlaviyoHeading(element);
    });
  }

  const pendingRoots = new Set();
  let normalizationScheduled = false;

  const flushNormalization = () => {
    normalizationScheduled = false;
    const roots = Array.from(pendingRoots).filter((root) => {
      if (!root.isConnected) return false;
      for (let parent = root.parentElement; parent; parent = parent.parentElement) {
        if (pendingRoots.has(parent)) return false;
      }
      return true;
    });
    pendingRoots.clear();
    roots.forEach(normalizeRoot);
  };

  const scheduleNormalization = (root) => {
    if (!(root instanceof Element) || root.matches('script, style, link, meta')) return;
    pendingRoots.add(root);
    if (normalizationScheduled) return;
    normalizationScheduled = true;
    window.requestAnimationFrame(flushNormalization);
  };

  const initialize = () => {
    normalizeRoot(document);

    new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node instanceof Element) scheduleNormalization(node);
        }
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();

